import React from "react";

// Dashboard
import EventManagement from "../dashboard/EventManagement";
import SalesMonitoring from "../dashboard/SalesMonitoring";
import WebsiteAnalytics from "../dashboard/WebsiteAnalytics";
import FinanceMonitoring from "../dashboard/FinanceMonitoring";
import Cryptocurrency from "../dashboard/Cryptocurrency";
import HelpdeskService from "../dashboard/HelpdeskService";
import StorageManagement from "../dashboard/StorageManagement";
import ProductManagement from "../dashboard/ProductManagement";

import ChiffreAffaires from "../dashboard/ChiffreAffaires";
import VentesJour from "../dashboard/VentesJour";
import StockCritique from "../dashboard/StockCritique";
import CommandesCours from "../dashboard/CommandesCours";
import FacturesImpayees from "../dashboard/FacturesImpayees";
import Clients from "../ventes/Clients";
import AjouterClient from "../ventes/AjouterClient";
import DetailClient from "../ventes/DetailClient";
import ModifierClient from "../ventes/ModifierClient";
import ImportClients from "../ventes/ImportClients";
import Produits from "../stock/Produits";
import AjouterProduit from "../stock/AjouterProduit";
import Categories from "../stock/Categories";
import ImportProduits from "../stock/ImportProduits";
import DetailProduit from "../stock/DetailProduit";
import ModifierProduit from "../stock/ModifierProduit";
import AjoutStock from "../stock/AjoutStock";
import DetailFacture from "../ventes/DetailFacture";
import Devis from "../ventes/Devis";
import NouveauDevis from "../ventes/NouveauDevis";
import DevisAcceptes from "../ventes/DevisAcceptes";
import DetailDevis from "../ventes/DetailDevis";
import ModifierDevis from "../ventes/ModifierDevis";
import EnvoyerEmailDevis from "../ventes/EnvoyerEmailDevis";
import Factures from "../ventes/Factures";
import NouvelleFacture from "../ventes/NouvelleFacture";
import FactureImpayees from "../ventes/FactureImpayees"; // Note: vous avez FactureImpayees et FacturesImpayees
import Avoirs from "../ventes/Avoirs";




import DashboardStats from "../stats/DashboardStats.js";
import ChiffreAffairess from "../stats/ChiffreAffaires.js";
// import EvolutionMensuelle from "../stats/EvolutionMensuelle.js";
// import TopProduits from "../stats/TopProduits.js";
// import TopClients from "../stats/TopClients.js";
// import DepensesAchats from "../stats/DepensesAchats.js";
// import TopFournisseurs from "../stats/TopFournisseurs.js";
// import RotationStock from "../stats/RotationStock.js";


import Commandes from "../achats/Commandes";
import NouvelleCommande from "../achats/NouvelleCommande";
import CommandesEnCours from "../achats/CommandesEnCours";
import CommandesRecues from "../achats/CommandesRecues";
import HistoriqueCommandes from "../achats/HistoriqueCommandes";
import DetailCommande from "../achats/DetailCommande";
import ModifierCommande from "../achats/ModifierCommande";

import StockCritiques from "../stock/StockCritique";

import AlertesStock from "../stock/AlertesStock.js";








// Imports
import EvolutionMensuelle from "../stats/EvolutionMensuelle";
import TopProduits from "../stats/TopProduits";
import TopClients from "../stats/TopClients";
import DepensesAchats from "../stats/DepensesAchats";
import TopFournisseurs from "../stats/TopFournisseurs";
import RotationStock from "../stats/RotationStock";

// Dans le tableau protectedRoutes


// Imports
import Tracabilite from "../stock/Tracabilite";

// Dans le tableau protectedRoutes


import Inventaires from "../stock/Inventaires";
import InventaireDetail from "../stock/InventaireDetail";



// Imports
import Fournisseurs from "../achats/Fournisseurs";
import AjouterFournisseur from "../achats/AjouterFournisseur";
import ModifierFournisseur from "../achats/ModifierFournisseur";
import DetailFournisseur from "../achats/DetailFournisseur";
import EvaluationFournisseurs from "../achats/EvaluationFournisseurs";

// Dans le tableau protectedRoutes


import DetailBonLivraison from "../ventes/DetailBonLivraison";
import ModifierBonLivraison from "../ventes/ModifierBonLivraison";
import BonsLivraison from "../ventes/BonsLivraison";
import NouveauBonLivraison from "../ventes/NouveauBonLivraison";
import BonsLivraisonEnCours from "../ventes/BonsLivraisonEnCours";

// ===== NOUVELLES IMPORTATIONS POUR LES RÈGLEMENTS =====
import Reglements from "../reglements/Reglements";
import NouveauReglement from "../reglements/NouveauReglement";
import Echeancier from "../reglements/Echeancier";
import DetailsReglement from "../reglements/DetailsReglement";
// ====================================================

// Apps
import GalleryMusic from "../apps/GalleryMusic";
import GalleryVideo from "../apps/GalleryVideo";
import Tasks from "../apps/Tasks";
import Contacts from "../apps/Contacts";
import Chat from "../apps/Chat";
import AppCalendar from "../apps/AppCalendar";
import Email from "../apps/Email";
import FileManager from "../apps/FileManager";
 
// Pages
import Pricing from "../pages/Pricing";
import Faq from "../pages/Faq";
     
import People from "../pages/People";
import Activity from "../pages/Activity";
import Events from "../pages/Events";


// UI Elements
import LayoutColumns from "../docs/LayoutColumns";
import LayoutGrid from "../docs/LayoutGrid";
import LayoutGutters from "../docs/LayoutGutters";
import Accordions from "../docs/Accordions";
import Alerts from "../docs/Alerts";
import Avatars from "../docs/Avatars";
import Badges from "../docs/Badges";
import Breadcrumbs from "../docs/Breadcrumbs";
import Buttons from "../docs/Buttons";
import Cards from "../docs/Cards";
import Carousels from "../docs/Carousels";
import Dropdowns from "../docs/Dropdowns";
import Images from "../docs/Images";
import Listgroup from "../docs/Listgroup";
import Markers from "../docs/Markers";
import Modals from "../docs/Modals";
import NavTabs from "../docs/NavTabs";
import OffCanvas from "../docs/OffCanvas";
import Paginations from "../docs/Paginations";
import Placeholders from "../docs/Placeholders";
import Popovers from "../docs/Popovers";
import Progress from "../docs/Progress";
import Spinners from "../docs/Spinners";
import Toasts from "../docs/Toasts";
import Tooltips from "../docs/Tooltips";
import Tables from "../docs/Tables";
import FormElements from "../docs/FormElements";
import FormSelects from "../docs/FormSelects";
import FormChecksRadios from "../docs/FormChecksRadios";
import FormRange from "../docs/FormRange";
import FormPickers from "../docs/FormPickers";
import FormLayouts from "../docs/FormLayouts";
import UtilBackground from "../docs/UtilBackground";
import UtilBorder from "../docs/UtilBorder";
import UtilColors from "../docs/UtilColors";
import UtilDivider from "../docs/UtilDivider";
import UtilFlex from "../docs/UtilFlex";
import UtilSizing from "../docs/UtilSizing";
import UtilSpacing from "../docs/UtilSpacing";
import UtilOpacity from "../docs/UtilOpacity";
import UtilPosition from "../docs/UtilPosition";
import UtilTypography from "../docs/UtilTypography";
import UtilShadows from "../docs/UtilShadows";
import UtilExtras from "../docs/UtilExtras";
import ApexCharts from "../docs/ApexCharts";
import ChartJs from "../docs/ChartJs";
import MapLeaflet from "../docs/MapLeaflet";
import MapVector from "../docs/MapVector";
import IconRemix from "../docs/IconRemix";
import IconFeather from "../docs/IconFeather";



import Scanner from "../modules/stock/Scanner/Scanner";


// Imports
import SocieteInfos from "../parametres/SocieteInfos";
import SocieteTaxes from "../parametres/SocieteTaxes";
import Utilisateurs from "../parametres/Utilisateurs";
import UtilisateursRoles from "../parametres/UtilisateursRoles";
import SauvegardeManuel from "../parametres/SauvegardeManuel";
import SauvegardeRestauration from "../parametres/SauvegardeResturation";
import DocumentsNumerotation from "../parametres/DocumentsNumerotation";


// Ne pas oublier les imports en haut :

import EditProfile from "../pages/EditProfile";
import Aide from "../pages/Aide";
import Confidentialite from "../pages/Confidentialite";
import Settings from "../pages/Settings";


import Profile from "../pages/Profile";


import StockInstantane from "../stock/StockInstantane";
import MouvementsStock from "../stock/MouvementsStock";
import ValeurStock from "../stock/ValeurStock";
import Tresorerie from "../stats/Tresorerie";
import EncoursClients from "../stats/EncoursClients";
import DashboardGlobal from "../dashboard/DashboardGlobal.jsx";



// Dans votre fichier routes.js, ajoutez :

const protectedRoutes = [
  { path: "pages/profile", element: <Profile /> },

 
  // Dashboard
  { path: "dashboard/finance", element: <FinanceMonitoring /> },
  { path: "dashboard/stats", element: <DashboardGlobal /> },
  { path: "dashboard/events", element: <EventManagement /> },
  { path: "dashboard/sales", element: <SalesMonitoring /> },
  { path: "dashboard/analytics", element: <WebsiteAnalytics /> },
  { path: "dashboard/crypto", element: <Cryptocurrency /> },
  { path: "dashboard/helpdesk", element: <HelpdeskService /> },
  { path: "dashboard/storage", element: <StorageManagement /> },
  { path: "dashboard/product", element: <ProductManagement /> },
  { path: "dashboard/impayes", element: <FacturesImpayees /> },
  { path: "dashboard/commandes", element: <CommandesCours /> },
  { path: "dashboard/stock-critique", element: <StockCritique /> },
  { path: "dashboard/ventes-jour", element: <VentesJour /> },
  { path: "dashboard/ca", element: <ChiffreAffaires /> },


  { path: "pages/profile", element: <Profile /> },
{ path: "pages/edit-profile", element: <EditProfile /> },
{ path: "pages/change-password", element: <Settings /> }, // Ou page dédiée
{ path: "pages/aide", element: <Aide /> },
{ path: "pages/confidentialite", element: <Confidentialite /> },


// Paramètres - Préférences


{ path: "parametres/societe/infos", element: <SocieteInfos /> },
{ path: "parametres/societe/taxes", element: <SocieteTaxes /> },
{ path: "parametres/utilisateurs", element: <Utilisateurs /> },
{ path: "parametres/utilisateursRoles", element: <UtilisateursRoles /> },
{ path: "parametres/sauvegarde/manuel", element: <SauvegardeManuel /> },
{ path: "parametres/sauvegarde/restauration", element: <SauvegardeRestauration /> },
{ path: "parametres/documents/numerotation", element: <DocumentsNumerotation /> },


  { path: "stats/ventes/mensuel", element: <EvolutionMensuelle /> },
{ path: "stats/ventes/top-produits", element: <TopProduits /> },
{ path: "stats/ventes/top-clients", element: <TopClients /> },
{ path: "stats/achats/depenses", element: <DepensesAchats /> },
{ path: "stats/achats/fournisseurs", element: <TopFournisseurs /> },
{ path: "stats/stock/rotation", element: <RotationStock /> },
// Imports


// Imports

{ path: "stock/tracabilite", element: <Tracabilite /> },


// Dans le tableau protectedRoutes
{ path: "stock/inventaire", element: <Inventaires /> },
{ path: "stock/inventaire/nouveau", element: <Inventaires /> }, // L'onglet gère l'affichage
{ path: "stock/inventaire/cours", element: <Inventaires /> },   // L'onglet gère l'affichage
{ path: "stock/inventaire/historique", element: <Inventaires /> }, // L'onglet gère l'affichage
{ path: "stock/inventaire/:id", element: <InventaireDetail /> },

// Dans le tableau protectedRoutes
{ path: "stock/alertes/critique", element: <AlertesStock /> },
// Note: Les sous-pages sont gérées par les onglets, pas besoin de routes séparées

  // Imports
// Imports


// Dans le tableau protectedRoutes
{ path: "stats/finances/tresorerie", element: <Tresorerie /> },
{ path: "stats/finances/encours", element: <EncoursClients /> },

  // Imports


// Dans le tableau protectedRoutes
{ path: "stats/dashboard", element: <DashboardStats /> },
{ path: "stats/ventes/ca", element: <ChiffreAffairess /> },
// { path: "stats/ventes/mensuel", element: <EvolutionMensuelle /> },
// { path: "stats/ventes/top-produits", element: <TopProduits /> },
// { path: "stats/ventes/top-clients", element: <TopClients /> },
// { path: "stats/achats/depenses", element: <DepensesAchats /> },
// { path: "stats/achats/fournisseurs", element: <TopFournisseurs /> },
// { path: "stats/stock/rotation", element: <RotationStock /> },


// Dans le tableau protectedRoutes
{ path: "achats/commandes", element: <Commandes /> },
{ path: "achats/commandesNouveau", element: <NouvelleCommande /> },
{ path: "achats/commandesCours", element: <CommandesEnCours /> },
{ path: "achats/commandesRecues", element: <CommandesRecues /> },
{ path: "achats/commandesHistorique", element: <HistoriqueCommandes /> },
{ path: "achats/commandes/:id", element: <DetailCommande /> },
{ path: "achats/commandesModifier/:id", element: <ModifierCommande /> },

{ path: "achats/fournisseurs", element: <Fournisseurs /> },
{ path: "achats/fournisseursAjouter", element: <AjouterFournisseur /> },
{ path: "achats/fournisseurs/modifier/:id", element: <ModifierFournisseur /> },
{ path: "achats/fournisseurs/:id", element: <DetailFournisseur /> },
{ path: "achats/fournisseursEvaluation", element: <EvaluationFournisseurs /> },
  
  // Ventes - Clients
  { path: "ventes/clients/liste", element: <Clients /> },
  { path: "ventes/clients/ajouter", element: <AjouterClient /> },
  { path: "ventes/clients/modifier/:id", element: <ModifierClient /> },
  { path: "ventes/clients/import", element: <ImportClients /> },
  { path: "ventes/clientsDetails/:id", element: <DetailClient /> },
  
  
  // Ventes - Factures
  { path: "ventes/factures/liste", element: <Factures /> },
  { path: "ventes/factures/nouveau", element: <NouvelleFacture /> },
  { path: "ventes/factures/impayees", element: <FactureImpayees /> },
  { path: "ventes/avoirs", element: <Avoirs /> },
  { path: "ventes/facturesDetails/:id", element: <DetailFacture /> },
  

  { path: "stock/scanner", element: <Scanner /> },
  // Ventes - Devis
  { path: "ventes/devisListe", element: <Devis /> },
  { path: "ventes/devis/nouveau", element: <NouveauDevis /> },
  { path: "ventes/devis/acceptes", element: <DevisAcceptes /> },
  { path: "ventes/DetailDevis/:id", element: <DetailDevis /> },
  { path: "ventes/devis/modifier/:id", element: <ModifierDevis /> },
  { path: "ventes/devis/envoyer/:id", element: <EnvoyerEmailDevis /> },

  // Ventes - Bons de livraison
  { path: "ventes/bl/modifier/:id", element: <ModifierBonLivraison /> },
  { path: "ventes/blDetails/:id", element: <DetailBonLivraison /> },
  { path: "ventes/blListe", element: <BonsLivraison /> },
  { path: "ventes/bl/nouveau", element: <NouveauBonLivraison /> },
  { path: "ventes/bl/en-cours", element: <BonsLivraisonEnCours /> },
  { path: "ventes/bl/:id", element: <BonsLivraison /> }, // Pour la vue détail (à créer)

  // ===== NOUVELLES ROUTES POUR LES RÈGLEMENTS =====
  // Ventes - Règlements
  { path: "ventes/reglements", element: <Reglements /> },
  { path: "ventes/NouveauReglement", element: <NouveauReglement /> },
  { path: "ventes/reglementsEcheancier", element: <Echeancier /> },
  { path: "ventes/reglements/:id", element: <DetailsReglement /> },
  // ================================================



  // Imports


// Dans le tableau protectedRoutes
{ path: "stock/etat/instantane", element: <StockInstantane /> },
{ path: "stock/etat/mouvements", element: <MouvementsStock /> },
{ path: "stock/etat/valeur", element: <ValeurStock /> },
{ path: "stock/etat/critique", element: <StockCritiques /> },


  
  // Stock - Produits
  { path: "stock/produits", element: <Produits /> },
  { path: "stock/produitsAjouter", element: <AjouterProduit /> },
  { path: "stock/produitsCategories", element: <Categories /> },
  { path: "stock/produits/import", element: <ImportProduits /> },
  { path: "stock/produits/:id", element: <DetailProduit /> },
  { path: "stock/produits/modifier/:id", element: <ModifierProduit /> },
  { path: "stock/mouvements/ajouter/:id", element: <AjoutStock /> },
  
  // Apps
  { path: "apps/gallery-music", element: <GalleryMusic /> },
  { path: "apps/gallery-video", element: <GalleryVideo /> },
  { path: "apps/tasks", element: <Tasks /> },
  { path: "apps/contacts", element: <Contacts /> },
  { path: "apps/chat", element: <Chat /> },
  { path: "apps/calendar", element: <AppCalendar /> },
  { path: "apps/email", element: <Email /> },
  { path: "apps/file-manager", element: <FileManager /> },
   
  // Pages
  { path: "pages/pricing", element: <Pricing /> },
  { path: "pages/faq", element: <Faq /> },
    
  { path: "pages/people", element: <People /> },
  { path: "pages/activity", element: <Activity /> },
  { path: "pages/events", element: <Events /> },
  { path: "pages/settings", element: <Settings /> },
  
  // Docs/UI Elements
  { path: "docs/layout/grid", element: <LayoutGrid /> },
  { path: "docs/layout/columns", element: <LayoutColumns /> },
  { path: "docs/layout/gutters", element: <LayoutGutters /> },
  { path: "docs/com/accordions", element: <Accordions /> },
  { path: "docs/com/alerts", element: <Alerts /> },
  { path: "docs/com/avatars", element: <Avatars /> },
  { path: "docs/com/badge", element: <Badges /> },
  { path: "docs/com/breadcrumbs", element: <Breadcrumbs /> },
  { path: "docs/com/buttons", element: <Buttons /> },
  { path: "docs/com/cards", element: <Cards /> },
  { path: "docs/com/carousel", element: <Carousels /> },
  { path: "docs/com/dropdown", element: <Dropdowns /> },
  { path: "docs/com/images", element: <Images /> },
  { path: "docs/com/listgroup", element: <Listgroup /> },
  { path: "docs/com/markers", element: <Markers /> },
  { path: "docs/com/modal", element: <Modals /> },
  { path: "docs/com/navtabs", element: <NavTabs /> },
  { path: "docs/com/offcanvas", element: <OffCanvas /> },
  { path: "docs/com/pagination", element: <Paginations /> },
  { path: "docs/com/placeholders", element: <Placeholders /> },
  { path: "docs/com/popovers", element: <Popovers /> },
  { path: "docs/com/progress", element: <Progress /> },
  { path: "docs/com/spinners", element: <Spinners /> },
  { path: "docs/com/toasts", element: <Toasts /> },
  { path: "docs/com/tooltips", element: <Tooltips /> },
  { path: "docs/com/tables", element: <Tables /> },
  { path: "docs/form/elements", element: <FormElements /> },
  { path: "docs/form/selects", element: <FormSelects /> },
  { path: "docs/form/checksradios", element: <FormChecksRadios /> },
  { path: "docs/form/range", element: <FormRange /> },
  { path: "docs/form/pickers", element: <FormPickers /> },
  { path: "docs/form/layouts", element: <FormLayouts /> },
  { path: "docs/chart/apex", element: <ApexCharts /> },
  { path: "docs/chart/chartjs", element: <ChartJs /> },
  { path: "docs/map/leaflet", element: <MapLeaflet /> },
  { path: "docs/map/vector", element: <MapVector /> },
  { path: "docs/icon/remix", element: <IconRemix /> },
  { path: "docs/icon/feather", element: <IconFeather /> },
  { path: "docs/util/background", element: <UtilBackground /> },
  { path: "docs/util/border", element: <UtilBorder /> },
  { path: "docs/util/colors", element: <UtilColors /> },
  { path: "docs/util/divider", element: <UtilDivider /> },
  { path: "docs/util/flex", element: <UtilFlex /> },
  { path: "docs/util/sizing", element: <UtilSizing /> },
  { path: "docs/util/spacing", element: <UtilSpacing /> },
  { path: "docs/util/opacity", element: <UtilOpacity /> },
  { path: "docs/util/position", element: <UtilPosition /> },
  { path: "docs/util/typography", element: <UtilTypography /> },
  { path: "docs/util/shadows", element: <UtilShadows /> },
  { path: "docs/util/extras", element: <UtilExtras /> }
];

export default protectedRoutes;